import React from 'react';

/**
 * Session expired page — Depth 0 (outside Shell).
 * Shown when API returns 401 for an expired JWT.
 * Offers re-login with redirect back to previous location.
 */
export const SessionExpiredPage: React.FC<{
  onNavigate: (view: string) => void;
  redirectPath?: string;
}> = ({ onNavigate, redirectPath }) => {
  const loginTarget = redirectPath
    ? `login?redirect=${encodeURIComponent(redirectPath)}`
    : 'login';

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: 'var(--bg-primary)', fontFamily: 'system-ui, sans-serif' }}
    >
      <div
        className="w-full max-w-sm rounded-lg p-6 text-center"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          border: '1px solid var(--border-default)',
        }}
      >
        <h1
          className="text-xl font-semibold mb-3"
          style={{ color: 'var(--text-primary)' }}
        >
          Session expired
        </h1>

        <p
          className="text-sm mb-6"
          style={{ color: 'var(--text-secondary)' }}
        >
          For security, sessions last 24 hours. Please log in again to continue.
        </p>

        <button
          onClick={() => onNavigate(loginTarget)}
          className="w-full rounded-md py-2.5 text-sm font-medium"
          style={{
            backgroundColor: 'var(--accent-amber)',
            color: '#0E1420',
          }}
        >
          Log in again
        </button>
      </div>
    </div>
  );
};
